import FooterDeliveryBox from '@/modules/ProductPage/components/Footer/components/FooterDeliveryBox';
import FooterReturnBox from '@/modules/ProductPage/components/Footer/components/FooterReturnBox';
import FooterSecurePaymentBox from '@/modules/ProductPage/components/Footer/components/FooterSecurePaymentBox';
import { FooterSectionWrapper } from '@/modules/ProductPage/components/Footer/FooterSection.styled';

const FooterSection = () => {
  return (
    <FooterSectionWrapper data-testid="footer-columns-section">
      <FooterSecurePaymentBox />
      <FooterDeliveryBox />
      <FooterReturnBox />
    </FooterSectionWrapper>
  );
};

export default FooterSection;
